import Hero from "../../components/Hero/Hero";
import Destination from "../../components/Destination/Destination";
import Trip from "../../components/Trip/Trip";
import Footer from "../../components/Footer/Footer";
function Home() {
  return (
    <div>
      <Hero
        cName="hero"
        heroImg="https://images.unsplash.com/photo-1539667468225-eebb663053e6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1417&q=80"
        title="Your Journey Your Story"
        text="Choose Your Favourite Destination"
        buttonText="Travel Plan"
        url="/"
        btnClass="show"
      />
      <Destination />
      <Trip />
      <Footer />
    </div>
  );
}

export default Home;
